import NotFound from '@/views/NotFound.vue';

const routes = [
  {
    path: '/',
    redirect: 'home',
  },
  {
    path: '/tos',
    name: 'tos',
    component: () => import(/* webpackChunkName: "home" */ '@/views/legal/Tos.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "home" */ '@/views/legal/Privacy.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "home" */ '@/views/legal/PrivacyPolicy.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Login.vue'),
  },
  {
    path: '/reset-password',
    name: 'resetPass',
    component: () => import(/* webpackChunkName: "home" */ '@/views/ResetPass.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Logout.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Register.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Ranking.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Search.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/search-tutorial',
    name: 'searchTutorial',
    component: () => import(/* webpackChunkName: "gameQuiz" */ '@/views/tutorial/SearchTutorial.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/rondo',
    name: 'rondo',
    component: () => import(/* webpackChunkName: "gameRondo" */ '@/views/Rondo.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/rondo-tutorial',
    name: 'rondoTutorial',
    component: () => import(/* webpackChunkName: "gameQuiz" */ '@/views/tutorial/RondoTutorial.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cards',
    name: 'cards',
    component: () => import(/* webpackChunkName: "gameCards" */ '@/views/Cards.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/cards-tutorial',
    name: 'cardsTutorial',
    component: () => import(/* webpackChunkName: "gameQuiz" */ '@/views/tutorial/CardsTutorial.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/quiz',
    name: 'quiz',
    component: () => import(/* webpackChunkName: "gameQuiz" */ '@/views/Quiz.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/quiz-tutorial',
    name: 'quizTutorial',
    component: () => import(/* webpackChunkName: "gameQuiz" */ '@/views/tutorial/QuizTutorial.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/iceberg',
    name: 'iceberg',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Iceberg.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/form',
    name: 'form',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Form.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '*',
    component: NotFound,
  },
];

export default routes;
